import type { FrontendWidget } from '../types';
import { AccordionComponent } from './AccordionComponent';
import type {
  AccordionConfig,
  AccordionItemConfig,
  AccordionItemResolved,
  AccordionResolved,
} from './types';
import type { CtaAction } from '@/types/ctaAction';

// `resolveNestedZones` wraps component fields in an array even when
// repeatable=false; unwrap to the single object the component expects.
const firstCta = (
  value: CtaAction | CtaAction[] | undefined,
): CtaAction | null =>
  Array.isArray(value) ? (value[0] ?? null) : (value ?? null);

const resolveItems = (
  items: AccordionItemConfig[] | undefined,
): AccordionItemResolved[] =>
  (items ?? [])
    .filter((item) => Boolean(item?.title))
    .map((item, index) => ({
      id: item.id ?? index,
      title: item.title ?? '',
      content: item.content ?? null,
    }));

/**
 * Inline widget — every value comes from the CMS block itself, so there is no
 * backend resolver and it must not be registered in `WidgetResolverRegistry`.
 */
export const accordionWidget: FrontendWidget<
  AccordionConfig,
  AccordionResolved
> = {
  componentType: 'widgets.accordion',
  displayName: 'Accordion',
  ComponentA: AccordionComponent,
  resolveSync: (config) => ({
    layout: config.layout ?? 'single',
    columns: config.columns ?? '2',
    itemBackground: config.itemBackground ?? 'none',
    introText: config.introText ?? null,
    items: resolveItems(config.items),
    itemsRight: resolveItems(config.itemsRight),
    cta: firstCta(config.cta),
    isFaq: config.isFaq ?? false,
  }),
};
